import React from "react";
import "./styles.scss";
import { Text, ContributeButton } from "atoms";
import { FooterColumn } from "molecules";
import { TEXTS } from "../../constants";

const LOGO = require("../../assets/icons/nalu/Dark.svg");

const generateOptions = () => {
  let columns = [ 
    [
      {href: "/#/legal", text: TEXTS.LEGAL_FOOTER},
      {href: "/#/terms", text: TEXTS.TERMS_FOOTER},
      {href: "#", text: `© ${new Date().getFullYear()}`}
    ]
  ]
  return columns.map(column => {
    return <FooterColumn id={Math.random()} options={column}/>
  })
}

export default props => (
  <div className="footer">
    <div className="footer-content">
      <img src={LOGO} alt="Nalu logo"/>
      <div className="footer-columns">
        <Text footer text={TEXTS.FOOTER_TITLE} />
        <div className="footer-columns-container">
          {generateOptions()}
          <ContributeButton/>
        </div>
      </div>
    </div>
  </div>
);

